<div class="conditional-expand-arrow-cell">
    <mat-icon (click)="onClick($event)" class="icon">
        {{data.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}
    </mat-icon>
    <div class="cell-value">{{cellValue}}</div>
</div>
